// Generated, DO NOT EDIT MANUALLY.
import { createTypedClient } from '../../../pplx/frontend/api-clients/core/client.js';
export const realtimeClient = createTypedClient();
export const createRealtimeClient = (config) => createTypedClient(config);
